module.exports = __webpack_public_path__ + "static/media/deep_refresh.5472e110.png";